import { Clock3, Eye } from "lucide-react";
import { normalizeAppearance } from "@/lib/lessonVisibility";

const secondsToClock = (seconds = 0) => {
  const value = Math.max(0, Number(seconds || 0));
  const minutes = Math.floor(value / 60);
  const rest = Math.floor(value % 60);
  return `${String(minutes).padStart(2, "0")}:${String(rest).padStart(2, "0")}`;
};

const clockToSeconds = (value) => {
  const [minutes, seconds] = String(value || "0:0").split(":").map(Number);
  return Math.max(0, (minutes || 0) * 60 + (seconds || 0));
};

export function LessonVisibilityEditor({ value, onChange, compact = false }) {
  const appearance = normalizeAppearance(value);
  const patch = (changes) => onChange({ ...appearance, ...changes });
  return <div className={`visibility-editor ${compact ? "compact" : ""}`}>
    <label><Eye/> POJAWIENIE SIĘ
      <select value={appearance.mode} onChange={(event) => patch({ mode: event.target.value })}>
        <option value="always">Od razu</option>
        <option value="lesson_open">Po czasie od otwarcia lekcji</option>
        <option value="date">Od konkretnej daty</option>
        <option value="video_time">Po obejrzeniu fragmentu wideo</option>
      </select>
    </label>
    {appearance.mode === "lesson_open" ? <label><Clock3/> OPÓŹNIENIE, SEKUNDY<input type="number" min="0" value={appearance.delay_seconds || 0} onChange={(event) => patch({ delay_seconds: Number(event.target.value) })}/></label> : null}
    {appearance.mode === "date" ? <label><Clock3/> DATA I CZAS<input type="datetime-local" value={appearance.reveal_at || ""} onChange={(event) => patch({ reveal_at: event.target.value })}/></label> : null}
    {appearance.mode === "video_time" ? <label><Clock3/> CZAS WIDEO (MM:SS)<input value={secondsToClock(appearance.video_seconds)} onChange={(event) => patch({ video_seconds: clockToSeconds(event.target.value) })} placeholder="03:30"/></label> : null}
  </div>;
}
